import MarkerClusterer from '@googlemaps/markerclustererplus';
class Mappa {
	constructor() {
		this.init = this.init.bind(this);
		this.generateInfoWindow = this.generateInfoWindow.bind(this);
		this.markerHover = this.markerHover.bind(this);
		this.markerOut = this.markerOut.bind(this);
		this.toggleChips = this.toggleChips.bind(this);
		this.resizeMappa = this.resizeMappa.bind(this);
	}

	init(serviziForMappa = []) {
		const markers = [];
		/* eslint-disable no-undef */
		this.mappa = new google.maps.Map(
			document.querySelector('.mappa-single'),
			{
				zoom: 6,
				center: { lat: 41.902782, lng: 12.496365 },
			}
		);
		window.addEventListener('resize', this.resizeMappa);
		this.btnOpenChipEl = document.querySelector('.mappa-titolo');
		if (this.btnOpenChipEl) {
			this.btnOpenChipEl.addEventListener('click', this.toggleChips);
			this.chipContainer = document.querySelector('.chip-container');
		}

		let serviziArray = serviziForMappa;
		if (typeof servizi !== 'undefined' && serviziForMappa.length < 1) {
			serviziArray = servizi;
		}
		serviziArray.map((servizio) => {
			const contentInfoPoint = this.generateInfoWindow(servizio);
			servizio.comuni.map((location) => {
				const marker = new google.maps.Marker({
					position: new google.maps.LatLng(
						location.lat,
						location.lng
					),
					map: this.mappa,
				});

				markers.push(marker);
				const infowindow = new google.maps.InfoWindow();
				google.maps.event.addListener(marker, 'mouseover', () => {
					this.markerHover(marker, contentInfoPoint, infowindow);
				});
				google.maps.event.addListener(marker, 'mouseout', () => {
					this.markerOut(marker, infowindow);
				});

				return location;
			});
			return true;
		});

		new MarkerClusterer(this.mappa, markers, {
			imagePath:
				'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
		});
		this.resizeMappa();
		/* eslint-enable no-undef */
	}

	resizeMappa() {
		if (window.innerWidth < 768) {
			window.requestAnimationFrame(() => {
				this.mappa.setZoom(5);
			});
		} else {
			window.requestAnimationFrame(() => {
				this.mappa.setZoom(6);
			});
		}
	}

	toggleChips() {
		this.btnOpenChipEl
			.querySelector('.mappa-arrow')
			.classList.toggle('open');
		this.chipContainer.classList.toggle('is-hidden');
	}

	generateInfoWindow(servizio) {
		this.divContainer = document.createElement('div');
		this.divCategoria = document.createElement('div');
		this.divCategoria.innerHTML = servizio.sottocategoria;
		this.divCategoria.className = 'infotpoint-sottocategoria';
		this.divContainer.appendChild(this.divCategoria);
		this.divNomeSerivzio = document.createElement('div');
		this.divNomeSerivzio.innerHTML = servizio.nome;
		this.divNomeSerivzio.className = 'infopoint-nome-servizio m-t-8';
		this.divContainer.appendChild(this.divNomeSerivzio);
		if (servizio.certificato) {
			this.certificato = document.createElement('div');
			this.certificato.className = 'm-t-8';
			this.iconaCertificato = document.createElement('img');
			this.spanCertificato = document.createElement('span');
			this.spanCertificato.innerHTML = 'Certificato da Telepass';
			this.spanCertificato.className = 'infopoint-certificato';
			this.certificato.appendChild(this.iconaCertificato);
			this.certificato.appendChild(this.spanCertificato);
			this.divContainer.appendChild(this.certificato);
		}
		return this.divContainer;
	}

	markerHover(marker, contentInfoPoint, infowindow) {
		infowindow.setContent(contentInfoPoint);
		infowindow.open(this.mappa, marker);
	}

	markerOut(marker, infowindow) {
		infowindow.close(this.mappa, marker);
	}
}

export default Mappa;
